import type { Week } from "./types";

export const DELIVERY_REQUEST_REGISTER_START_FILE_NAME =
  "RegistrationDeliveryRequest";

/**
 * 曜日表示順を表す定数。
 */
export const WEEKS: Array<Week> = ["日", "月", "火", "水", "木", "金", "土"];
